<template>
  <div>
    <div class="y-cust-search-ctr" v-if="showSearch">
      <el-autocomplete
        prefix-icon="el-icon-search"
        v-model="queryString"
        select-when-unmatched
        :fetch-suggestions="querySearch"
        @change="searchCsskey(queryString)"
        @select="searchCsskey(queryString)"
        @clear="clearSearch"
        :trigger-on-focus="false"
        placeholder="Search"
        type="text"
        class="custom-icon cust-search-input"
        clearable
      ></el-autocomplete>
    </div>
    <div>
      <div v-if="showSearchField" class="y-search-form-ctr">
        <cust-conditional-render :dataProps="searchFormField" />
      </div>
      <div v-else class="y-cust-form-ctr">
        <!-- <div class="non-accordion-form-ctr">
          <div
            class="y-form-row"
            v-for="(component, index) in loadedCss[0] ? loadedCss[0].form:''"
            :key="index"
          >
            <cust-conditional-render :dataProps="component" />
          </div>
        </div>-->
        <el-collapse accordion class="y-cust-accordion-ctr">
          <div v-for="item in designAccordionList" :key="item.title">
            <el-collapse-item
              :label="item.title"
              :title="item.title"
              :name="item.title"
              v-if="item.accordion !== false && item.show !== false"
              :autoid="item.autoid"
              @click.native="
              showHighlight(item.highlight_class),
                switchPreviewPage(item.previewPageName)
            "
            >
              <div class="y-form-row" v-for="(component, index) in item.form" :key="index">
                <cust-conditional-render :dataProps="component" />
              </div>
              <el-collapse accordion class="y-inner-accordion-ctr" v-if="item.innerAccordion">
                <div v-for="item1 in item.innerAccordion" :key="item1.title">
                  <el-collapse-item
                    :label="item1.title"
                    :title="item1.title"
                    :name="item1.title"
                    :autoid="item.autoid"
                    @click.native.stop="showHighlight(item1.highlight_class), switchPreviewPage(item1.previewPageName)"
                  >
                    <div class="y-form-row" v-for="(component, index) in item1.form" :key="index">
                      <cust-conditional-render :dataProps="component" />
                    </div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </el-collapse-item>
          </div>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import CustConditionalRender from '../../components/custConditionalRender.vue'
import { mapActions } from 'vuex'
import { custToolHelper } from '../../mixins/custToolHelper'
import _ from 'underscore'
export default {
  components: {
    'cust-conditional-render': CustConditionalRender
  },
  props: {},
  data() {
    return {
      queryString: '',
      compStoreName: 'cssStore',
      showSearch: false
    }
  },
  created() {
    this.$store.state.cssStore.showSearchField = false
  },
  mixins: [custToolHelper],
  watch: {
    loadedCss: {
      deep: true,
      handler: 'updateDataSavedStatus'
    }
  },
  computed: {
    loadedCss() {
      console.log(this.$store.state.cssStore.loadedCss)
      return this.$store.state.cssStore.loadedCss
    },
    designAccordionList() {
      var designAccordionsList = this.loadedCss
      var optedApps = this.$store.state.appStore.optedApps
      if (optedApps && optedApps.pfm && !optedApps.pfm.enabled) {
        let wellnessApps = _.findWhere(designAccordionsList, {
          ref_id: 'wellness-finapp'
        })
        wellnessApps['show'] = false
      }
      return designAccordionsList
    },
    showSearchField() {
      return this.$store.state.cssStore.showSearchField
    },
    searchFormField() {
      return this.$store.state.cssStore.searchFormField
    }
  },
  methods: {
    ...mapActions(['searchCsskey']),
    getSearchData() {
      return this.$store.state.cssStore.loadedCss
    }
  }
}
</script>

<style lang="scss">
.non-accordion-form-ctr {
  .y-form-row:first-child {
    margin-top: 16px;
  }
}
</style>
